"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Callout = _interopRequireDefault(require("../../elements/Callout/Callout"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _TwoColumnLayout = _interopRequireDefault(require("../../layouts/TwoColumnLayout/TwoColumnLayout"));
var _excluded = ["caption", "value"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var StyledVerticalDivider = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\ndisplay: flex; \njustify-content: center; \nalign-items: center;\nborder-right: 3px solid var(--bf-core-white);\nheight: 100%;\nbox-sizing: border-box;\nmargin: 0px 20px;\npadding: 40px 0px;\n\n"])));
var ValueStyle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  align-items: center;\n  font-weight: 700;\n  font-family: var(--bf-lead-font);\n  line-height: 105%;\n  font-size: 100px; \n  color: white\n  "])));
var CaptionStyle = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  align-items: center;\n  text-align: left;\n  justify-content: flex-start;\n  font-weight: 700;\n  font-family: var(--bf-lead-font);\n  line-height: 105%;\n  font-size: 30px; \n  color: white\n  "])));
var StyledHeading = (0, _styledComponents.default)(_Heading.default)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: left;\n  width: 70%;\n"])));
var StyledCallout = (0, _styledComponents.default)(_Callout.default)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: left;\n"])));
var StatStylesItem = (0, _styledComponents.default)(_Grid.default)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["  \n    text-align: center;\n    justify-content: flex-start;\n    background-color: var(--bf-core-teal);\n    border-color: var(--bf-core-teal);\n    border-style: solid;\n    border-width: 3px;\n    border-radius: 40px;\n    width: 100%;\n    color: white;\n\n"])));
var HorizontalStat = function HorizontalStat(_ref) {
  var caption = _ref.caption,
    value = _ref.value,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "flex-start"
  }, props), _react.default.createElement(StatStylesItem, {
    item: true
  }, _react.default.createElement(_ThreeColumnLayout.default, {
    variant: "TwoOneNineRatio",
    spansFullPage: true
  }, _react.default.createElement(_Callout.default, {
    small: true,
    white: true
  }, " ", value, " "), _react.default.createElement(StyledVerticalDivider, null), _react.default.createElement(StyledHeading, {
    h4: true,
    white: true
  }, caption))));
};
var _default = HorizontalStat;
exports.default = _default;